import React, { useContext, useEffect, useState } from 'react';
import Menu, { MENU_CATEGORY } from '../../../organisms/menu/Menu';
import Paragraph from '../../../atoms/paragraphs/Paragraph';
import { FormattedMessage, injectIntl } from 'react-intl';
import InfoDisplayGrid from '../../../organisms/containers/info-display-grid/InfoDisplayGrid';
import InfoDisplayCard from '../../../organisms/cards/InfoDisplayCard';
import { ContactService } from '../../../../services';
import moment from 'moment';
import 'moment/locale/pt';
import 'moment/locale/es';
import Button from '../../../atoms/buttons/Button';
import HistoryComponent from '../../../organisms/history/HistoryComponent';
import { SubscriptionService } from '../../../../services/SubscriptionService';
import Icon from '../../../atoms/icons/Icon';
import { downloadPdfFile } from '../../../organisms/tables/util/pdfManager';
import { buildPath } from '../../../organisms/containers/util/pathHelper';
import { AppContext } from '../../../../contexts/AppContext';
import { CANCEL_SUBSCRIPTION_ACTIVE, DELETE_ACCOUNT_ACTIVE } from './constants';

const DetailsLayout = (props) => {
  const cancelSubscriptionActive = CANCEL_SUBSCRIPTION_ACTIVE; // TODO: Remove this when the action is implemented
  const deleteAccountActive = DELETE_ACCOUNT_ACTIVE; // TODO: Remove this when the action is implemented
  const { appState } = useContext(AppContext);
  const [subscriptionDetails, setSubscriptionDetails] = useState(undefined);
  const [billingHistory, setBillingHistory] = useState({
    billing_history: [],
    pagination: {
      total_pages: 0,
    },
  });
  const [historyPage, setHistoryPage] = useState(1);

  const historyConfig = {
    sequence_number: {
      headerClassName: 'col-3 col-md-2',
      headerValue: props.intl.messages['billingHistoryHeader_DocumentNumber'],
      rowClassName: 'col-3 col-md-2 font-bold color-gray-500',
    },
    date: {
      headerClassName: 'd-none d-sm-flex col-3 col-md-2',
      headerValue: props.intl.messages['billingHistoryHeader_Date'],
      rowClassName: 'col-3 col-md-2 color-gray-500 d-none d-sm-flex ',
      formatValue: (date) =>
        new Intl.DateTimeFormat('pt-PT', {
          timeZone: 'Europe/Lisbon',
        }).format(new Date(date)),
    },
    total_before_taxes: {
      headerClassName: 'd-none d-md-flex col-3 col-md-2',
      headerValue: props.intl.messages['billingHistoryHeader_RawAmount'],
      rowClassName: 'col-3 col-md-2 color-gray-500 d-none d-md-flex',
      suffix: ' €',
      collapse: true,
    },
    total_taxes: {
      headerClassName: 'd-none d-md-flex col-3 col-md-2',
      headerValue: props.intl.messages['billingHistoryHeader_TaxAmount'],
      rowClassName: 'col-3 col-md-2 color-gray-500 d-none d-md-flex',
      suffix: ' €',
    },
    total: {
      headerClassName: 'col-3 col-md-2',
      headerValue: props.intl.messages['billingHistoryHeader_TotalAmount'],
      rowClassName: 'col-3 col-md-2 color-red-200 font-bold',
      suffix: ' €',
    },
    id: {
      headerClassName: 'col-3 col-md-2',
      headerValue: props.intl.messages['billingHistoryHeader_Invoice'],
      rowClassName: 'col-3 col-md-2 color-gray-500',
      formatValue: (invoice_id) => {
        return (
          <div
            className='button button-icon-self button-download-pdf vertical-sep'
            onClick={() => invoice_id && downloadPdfFile(invoice_id)}
          >
            <Icon className='icon far fa-file-pdf' />
          </div>
        );
      },
    },
  };

  const historyActions = {
    /*clickable: true,
    onAction: (element) => {
      window.open(element.permalink, '_blank');
    },*/
  };

  const onPageChange = async (page) => {
    setHistoryPage(page);
    const billingHistory = await ContactService.getBillingHistory(page);
    setBillingHistory(billingHistory);
  };

  useEffect(() => {
    const fetchSubscriptionDetails = async () => {
      const response = await SubscriptionService.getSubscriptionDetails();

      if (!response.error) {
        setSubscriptionDetails(response.subscription);
      }
    };

    const fetchBillingHistory = async () => {
      const response = await ContactService.getBillingHistory(historyPage);

      if (!response.error) {
        setBillingHistory(response);
      }
    };

    fetchSubscriptionDetails();
    fetchBillingHistory();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div id='main-content' className='container --subscription'>
      <div className='row mx-0 justify-content-center'>
        <div className='col-lg-9 ps-md-0'>
          <div className='d-flex flex-column w-100'>
            <div className='col-12 px-0'>
              <Paragraph id='subscription-title' className='text-header h2'>
                {props.intl.messages['subscriptionTitle']}
              </Paragraph>

              <div className='sep-light mt-2' />
            </div>

            {(subscriptionDetails?.payment_status === 'on_hold' && (
              <div className='message-container pending d-flex flex-row col-12 col-lg-10 px-0 mt-4'>
                <div className='message-wrapper d-flex flex-grow-1 px-4 py-3'>
                  <Icon className='message-icon icon fas fa-2x fa-exclamation-triangle my-auto' />
                  <Paragraph className='text-paragraph message-text ps-3 my-0'>
                    {props.intl.messages['subscriptionPaymentStatusPending']}
                  </Paragraph>
                </div>
              </div>
            )) || <></>}

            {(subscriptionDetails?.payment_status === 'failed' && (
              <div className='message-container failed d-flex flex-row col-12 col-lg-10 px-0 mt-4'>
                <div className='message-wrapper d-flex flex-grow-1 px-4 py-3'>
                  <Icon className='message-icon icon fas fa-2x fa-times-circle my-auto' />
                  <Paragraph className='text-paragraph message-text ps-3 my-0'>
                    {props.intl.messages['subscriptionPaymentStatusFailed']}
                  </Paragraph>
                </div>
              </div>
            )) || <></>}

            <div className='d-flex flex-row flex-wrap col-12 col-lg-10 px-0 mt-4'>
              <div className='d-flex flex-row col-12 col-lg-8 px-0'>
                {(subscriptionDetails && (
                  <InfoDisplayGrid gridSize={{ xs: '12', md: '6', lg: '6' }}>
                    <InfoDisplayCard
                      title={props.intl.messages['subscriptionAccountPlan']}
                      amount={subscriptionDetails.plan?.name}
                    />

                    <InfoDisplayCard
                      title={props.intl.messages['subscriptionMonthlyFee']}
                      amount={`${subscriptionDetails.monthly_fee || 0}€`}
                      /*description={
                        subscriptionDetails.period === 'year'
                          ? props.intl.messages['subscriptionAnnualPaymentType']
                          : props.intl.messages[
                              'subscriptionMonthlyPaymentType'
                            ]
                      }*/
                    />

                    <InfoDisplayCard
                      title={
                        props.intl.messages['subscriptionAvailableDocuments']
                      }
                      amount={
                        subscriptionDetails.documents_paid -
                          subscriptionDetails.documents_used || '0'
                      }
                      colorClass='color-brand-primary'
                      description={
                        <FormattedMessage
                          id='subscriptionUsedDocuments'
                          values={{
                            usedDocuments:
                              subscriptionDetails.documents_used || 0,
                            totalDocuments:
                              subscriptionDetails.documents_paid || 0,
                          }}
                        />
                      }
                    />

                    <InfoDisplayCard
                      title={props.intl.messages['subscriptionNextCycle']}
                      amount={
                        subscriptionDetails.next_cycle
                          ? moment(subscriptionDetails.next_cycle)
                              .locale(props.intl.locale)
                              .format('DD MMM YYYY')
                          : '-'
                      }
                    />

                    <InfoDisplayCard
                      title={props.intl.messages['subscriptionPaymentMethod']}
                      amount={
                        appState.accountTrial === 'true'
                          ? 'Trial'
                          : props.intl.messages[
                              'subscriptionPaymentMethod_' +
                                subscriptionDetails.payment_method
                            ] ||
                            props.intl.messages[
                              'subscriptionPaymentMethod_other'
                            ]
                      }
                    />

                    <InfoDisplayCard
                      title={props.intl.messages['subscriptionRenewAt']}
                      amount={
                        subscriptionDetails.end_date
                          ? moment(subscriptionDetails.end_date)
                              .locale(props.intl.locale)
                              .format('DD MMM YYYY')
                          : '-'
                      }
                    />

                    <InfoDisplayCard
                      title={props.intl.messages['subscriptionType']}
                      amount={
                        props.intl.messages['paymentCycle_' + subscriptionDetails.period] || subscriptionDetails.period + " " + props.intl.messages['paymentCycle_unknown']
                      }
                    />

                    <InfoDisplayCard
                      title={props.intl.messages['subscriptionAvailableCredit']}
                      amount={`${subscriptionDetails.available_credit || 0}€`}
                    />
                  </InfoDisplayGrid>
                )) || <></>}
              </div>

              <div className='d-flex flex-row col-12 col-lg-4 px-0'>
                <div className='d-flex flex-column flex-grow-1 checkout-card bg-brand-100 ms-0 ms-lg-3 mb-0 mb-lg-3 p-4'>
                  <Paragraph className='title text-header h4 mb-4 font-bold'>
                    {props.intl.messages['subscriptionMoreDocuments']}
                  </Paragraph>

                  <Paragraph className='mb-4'>
                    {
                      props.intl.messages[
                        'subscriptionMoreDocumentsDescription1'
                      ]
                    }
                  </Paragraph>

                  <Paragraph className='mb-4'>
                    {
                      props.intl.messages[
                        'subscriptionMoreDocumentsDescription2'
                      ]
                    }
                  </Paragraph>

                  <Button
                    className='button button-primary w-100 mt-auto'
                    // DISABLED ON AUGUST 20TH 2025 - CLIENTS WITH MB_REF GENERATED WANTED TO PAY WITH ANOTHER METHOD.
                    // disabled={subscriptionDetails?.payment_status === 'on_hold'}
                    id='choose-plan'
                    label={
                      props.intl.messages['subscriptionMoreDocumentsAction']
                    }
                    onClick={() =>
                      (window.location.href = buildPath(
                        `accounts/checkout?page=one&cycle=${subscriptionDetails?.period ? subscriptionDetails.period : 'month'}`
                      ))
                    }
                  />
                </div>
              </div>
            </div>

            {(billingHistory.billing_history.length > 0 && (
              <div className='col-12 col-lg-10 px-0 mt-4'>
                <HistoryComponent
                  config={historyConfig}
                  data={billingHistory.billing_history}
                  pagination={billingHistory.pagination}
                  actions={historyActions}
                  historyPage={historyPage}
                  historyTitle={props.intl.messages['billingHistoryTitle']}
                  onPageChange={onPageChange}
                  initialExpanded={true}
                ></HistoryComponent>
              </div>
            )) || <></>}

            {((cancelSubscriptionActive || deleteAccountActive) && (
              <div className='subscription-actions-container d-flex flex-row col-12 col-lg-10 px-0 mt-4 mb-4'>
                {(cancelSubscriptionActive && (
                  <div className='d-flex flex-column me-auto'>
                    <Paragraph className='small mb-2'>
                      {props.intl.messages['subscriptionCancelDescription']}
                    </Paragraph>
                    <div className='d-flex'>
                      <Button
                        id='subscription-cancel'
                        className='button button-plain-text p-0'
                        onClick={() => {
                          console.log('Cancel subscription');
                        }}
                      >
                        <FormattedMessage id={'subscriptionCancel'} />
                      </Button>
                    </div>
                  </div>
                )) || <></>}

                {(deleteAccountActive && (
                  <div className='d-flex flex-column ms-auto'>
                    <Paragraph className='small mb-2'>
                      {
                        props.intl.messages[
                          'subscriptionAccountDeleteDescription'
                        ]
                      }
                    </Paragraph>
                    <div className='d-flex'>
                      <Button
                        id='subscription-account-delete'
                        className='button button-plain-text p-0 ms-auto'
                        onClick={() => {
                          console.log('Delete account');
                        }}
                      >
                        <FormattedMessage id={'subscriptionAccountDelete'} />
                      </Button>
                    </div>
                  </div>
                )) || <></>}
              </div>
            )) || <></>}
          </div>
        </div>

        <div className='col-lg-3 pe-md-0'>
          <Menu {...props} activeCategory={MENU_CATEGORY.ACCOUNT} />
        </div>
      </div>
    </div>
  );
};

export default injectIntl(DetailsLayout);
